import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import { getUrlParam } from '../../helper/common-helper';

import { formatMessage } from '../../intl/helper';
import FloatingScrollSelector from '../common/floating-scroll-selector';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import PayMethodOption from '../order/select/pay-method-option';

import { BrandLanguages } from '../../helper/const/languages';

import './language-recharge.scss';
import globalText from '../../intl/messages/global';

const shopId = getUrlParam('shopId');

class LanguageRecharge extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tip: null,
      icon: null,
      showModal: false,
      defaultIndex: 1,
      isSubmit: false,
      customerRange: [],
      container: null,
    };

    this.showChangeList = this.showChangeList.bind(this);
    this.clearChildView = this.clearChildView.bind(this);
    this.getInitLanguageRange = this.getInitLanguageRange.bind(this);

    this.confirmPeopleCountAndSubmit = this.confirmPeopleCountAndSubmit.bind(this);

    this.toggleSelectorCheckedStatus = this.toggleSelectorCheckedStatus.bind(this);

    this.renderSelector = this.renderSelector.bind(this);
  }

  componentWillMount() {
    // 获取brandId
    this.brandId = sessionStorage.getItem('brandId');

    const userLanguage = Cookies.get(`language_switch_${this.brandId}`);
    const localBrandLanguages = sessionStorage.getItem('brandLanguages');
    const brandLanguages = localBrandLanguages ? localBrandLanguages.split(',') : [];
    if (brandLanguages.length === 0) {
      return; // 如果品牌列表为空，则不展示语言切换
    }
    const supportLanguages = BrandLanguages.filter(item => brandLanguages.includes(item.type));

    this.getInitLanguageRange(supportLanguages, userLanguage);
    const nowLocal = supportLanguages.filter(item => item.type === userLanguage);

    const { tip, icon, id } = nowLocal.length !== 0 ? nowLocal[0] : supportLanguages[0];
    this.setState({
      tip,
      icon,
      defaultIndex: id,
    });
  }

  componentDidMount() {
    const div = document.createElement('div');
    div.id = 'language__mask';
    document.body.appendChild(div);
    this.renderSelector();
  }

  getInitLanguageRange(range, userLanguage) {
    range.forEach((item, index) => {
      item.id = index;
      item.isChecked = false;
    });
    this.setState({
      customerRange: range,
    });
  }

  showChangeList() {
    const newHH = this.state.customerRange.map((item, index) => ({
      ...item,
      isChecked: index === this.state.defaultIndex,
    }));
    this.setState({ customerRange: newHH, showModal: true }, () => {
      this.renderSelector();
    });
    this.props.onChange(true);
  }

  clearChildView(e) {
    e.stopPropagation();

    this.setState(
      {
        isSubmit: false,
        showModal: false,
      },
      () => {
        this.renderSelector();
      },
    );
    this.props.onChange(false);
  }

  confirmPeopleCountAndSubmit(newCount) {
    const localLanguage = Cookies.get(`language_switch_${this.brandId}`);
    const { type, id, icon, tip } = newCount;
    if (type === localLanguage) return;
    Cookies.set(`language_switch_${this.brandId}`, type, { expires: 90 }); // 90天有效期
    this.setState({
      defaultIndex: id,
      tip,
      icon,
    });
    // 因为很多页面在初始化时翻译了文案，所以此处统一重载页面
    // reload(type);

    location.reload();
  }

  toggleSelectorCheckedStatus(value) {
    const newHH = this.state.customerRange.map((item, index) => ({
      ...item,
      isChecked: index === value,
    }));

    this.setState({ customerRange: newHH, defaultIndex: value }, () => {
      this.renderSelector();
    });
  }

  renderSelector() {
    ReactDOM.render(
      <ReactCSSTransitionGroup transitionName="slideup" transitionEnterTimeout={600} transitionLeaveTimeout={600}>
        {this.state.showModal && (
          <FloatingScrollSelector
            selectorTitle={formatMessage(globalText.languageSwitch)}
            closeSelector={this.clearChildView}
            setSelectedOption={this.confirmPeopleCountAndSubmit}
            toggleSelectorCheckedStatus={this.toggleSelectorCheckedStatus}
            optionComponent={PayMethodOption}
            dataList={this.state.customerRange}
            defaultCheckedIndex={this.state.defaultIndex}
          />
        )}
      </ReactCSSTransitionGroup>,
      document.getElementById('language__mask'),
    );
  }

  render() {
    const { tip } = this.state;
    return (
      <div>
        {tip && (
          <div className="language-recharge" onTouchTap={this.showChangeList}>
            <span className="language-recharge__tip">{this.state.tip}</span>
            <div className="language-recharge__icon" style={{ backgroundImage: `url(${this.state.icon})` }}></div>
          </div>
        )}
      </div>
    );
  }
}

LanguageRecharge.propTypes = {
  onChange: React.PropTypes.func,
};
LanguageRecharge.defaultProps = {
  onChange: () => {},
};

export default LanguageRecharge;



// WEBPACK FOOTER //
// ./src/component/language-recharge/language-recharge.jsx